
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'

export default defineComponent({
    props: {
        timeFrom: {
            type: [Date, null] as PropType<Date | null>,
            default: null,
        },
        timeTo: {
            type: [Date, null] as PropType<Date | null>,
            default: null
        }
    },
    setup(props) {
        const selectedTimeSlotPeriod = computed(() => {
            if (props.timeFrom && props.timeTo) {
                const hoursFrom = props.timeFrom.getHours().toString().padStart(2, '0')
                const minutesFrom = props.timeFrom.getMinutes().toString().padStart(2, '0')

                const hoursTo = props.timeTo.getHours().toString().padStart(2, '0')
                const minutesTo = '00'

                return `${hoursFrom}:${minutesFrom} - ${hoursTo}:${minutesTo}`
            } else if (props.timeFrom && !props.timeTo) {
                const hoursFrom = props.timeFrom.getHours().toString().padStart(2, '0')
                const minutesFrom = props.timeFrom.getMinutes().toString().padStart(2, '0')

                return `${hoursFrom}:${minutesFrom} - `
            }

            return ''
        })

        return {
            selectedTimeSlotPeriod
        }
    }
})
